<template>
  <div id="data-view3">
    <div class="flex h-100 flex-wrap pagebg" style="overflow: hidden">
      <!-- 加载动画 -->
      <div class="loads" v-show="isload">
        <dv-loading style="width: 250px; height: 250px">Loading...</dv-loading>
      </div>

      <div class="etime">{{ nowTime }}</div>
      <div class="etime1">最后更新:{{ updateTimeText }}</div>


      <div @click="signOut" class="power">
        <i style="cursor: pointer" class="el-icon-back"></i>
      </div>
      <div class="logoImg">
        <img style="height: 0.8rem" :src="logoSrc"/>
      </div>
      <header class="w-100 h-10 flex j-center a-center">
        <dv-decoration-5
          :dur="10"
          style="position: absolute; bottom: 0; right: 0; height: 50%"
          class="w-100"
        />
        <div class="font-big font-weight light-title" style="font-size:0.7rem;">
          {{ title }}
        </div>
      </header>
      <div class="p w-25 h-60 flex " style="text-align: center">
        <!--左侧年份选择-->
        <dv-border-box-7 >
          <div style="height: 100%; display: flex; padding: 0 0.1rem">
            <div style="vertical-align: center; margin: auto 0; width: 100%; height: 80%;">
              <el-dropdown @command="yearFilter" trigger="click" style="width: 80%;margin-bottom: 20px;" >
                <el-button
                  style="color: #fff; font-size: 0.4rem; width: 100%;background-color: rgba(6, 30, 93, 0.5);border-radius:0px; border: 1px solid rgba(0, 44, 81, 0.8);">
                  {{ year }}
                </el-button>
                <el-dropdown-menu slot="dropdown" style="width: 16%; text-align: center">
                  <el-dropdown-item :command="y" v-for="(y, r) in yearArry" :key="r" style="width: 100%"
                  ><span style="color: black; font-size: 22px; font-weight: bold"
                  >{{ y }} 年</span
                  >
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <div id="monthEchart" style="height: 80%"></div>
            </div>

          </div>
        </dv-border-box-7>
      </div>
      <div class="p w-50 h-60 flex">
        <!--中间日历-->
        <dv-border-box-7>
          <div class="w-100 h-95 flex" id="deptCloseRateEchart"></div>
        </dv-border-box-7>
      </div>

      <div class="p w-25 h-60 flex">
        <!-- 右侧图标-->
        <dv-border-box-7>
          <table class="right_table">
            <tbody>
            <tr>
              <td>
                <div style="background-color: #ff0000;height: 0.4rem;width: 1.6rem"></div>
              </td>
              <td>客户质量问题</td>
            </tr>
            <tr>
              <td>
                <div style="background-color: #E5E96E;height: 0.4rem;width: 1.6rem"></div>
              </td>
              <td>内部质量问题</td>
            </tr>
            <tr>
              <td>
                <div style="background-color: #00b050;height: 0.4rem;width: 1.6rem"></div>
              </td>
              <td>无质量问题</td>
            </tr>
            </tbody>
          </table>
        </dv-border-box-7>
      </div>

	  <div class="w-100 h-5 flex">
	  		  <div class="line_title">事件记录</div>

	  </div>


	   <div class="p w-15 h-25 flex"></div>
      <div class="p w-70 h-25 flex">
        <dv-border-box-7>
          <dv-scroll-board :config="config" />
        </dv-border-box-7>
      </div>
 <div class="p w-15 h-35 flex"></div>

      <el-dialog
        title="设置"
        width="50%"
        :close-on-click-modal="false"
        :visible.sync="dialogFormVisible"
      >
        <el-form :model="qcFrom" status-icon ref="qcFrom" label-width="1.4rem">
          <el-form-item label="日期" prop="openedDate" >
            <el-input v-model="qcFrom.openedDate" disabled="disabled">
            </el-input>
          </el-form-item>
          <el-form-item label="状态">
            <el-select
              :class="{selectFrom0:qcFrom.status==0,selectFrom1:qcFrom.status==1,selectFrom2:qcFrom.status==2 }"
              v-model="qcFrom.status" style="width: 100%;">
              <el-option label="无质量问题" style="background-color: #00b050;font-size: 0.3rem;height: 0.5rem;line-height:0.5rem" value='0'></el-option>
              <el-option label="内部质量问题" style="background-color: #E5E96E;font-size: 0.3rem;height: 0.5rem;line-height:0.5rem" value='1'></el-option>
              <el-option label="客户质量问题" style="background-color: #ff0000;font-size: 0.3rem;height: 0.5rem;line-height:0.5rem" value='2'></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="备注">
            <el-input type="textarea" v-model="qcFrom.remark">
            </el-input>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="addQcDay()">确认</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
    </div>
  </div>
</template>

<script>
  import API from "@/utils/api";
  import format from "date-fns/format";
  import router from "../../../../router";

  export default {
    name: "board",
    data() {
      return {
        logoSrc: "/assets/img/logo_light.png",
        activeName: "first",
        websock: null,
        isload: false,
        reconnectData: null,
        lockReconnect: false,
        title: "质量日历",
        msg: "home",
        dataSet: {},
        now: new Date(),
        year: 2021,
        month: 12,
        monthText: "December",
        yearArry: [],
        dialogFormVisible: false,
        qcFrom: {
          openedDate: 0,
          status: "0",
          remark: ''
        },
        monthEchartData:
          [
            [0, 3, null, 0], [1, 3, 1, 2], [2, 3, 2, 4], [3, 3, null, 0],
            [0, 2, 3, 1], [1, 2, 4, 1], [2, 2, 5, 1], [3, 2, 6, 1],
            [0, 1, 7, 1], [1, 1, 8, 0], [2, 1, 9, 0], [3, 1, 10, 0],
            [0, 0, null, 0], [1, 0, 11, -1], [2, 0, 12, -1], [3, 0, null, 0]
          ],
        monthIndex: 0,
        dayIndex: [],
        option: {},
        config: {
          startCharts: "",
          header: ["<span style='font-size: 0.24rem;'>发生日期</span>",
            "<span style='font-size: 0.24rem;'>事件类型</span>",
            "<span style='font-size: 0.24rem;'>事件描述</span>"],
          headerBGC: "rgba(6, 30, 93, 0.5)",
          headerHeight: this.fontSize(0.5),
          oddRowBGC: "rgba(0, 44, 81, 0.8)",
          evenRowBGC: "rgba(10, 29, 50, 0.8)",
          rowNum: 3,
          columnWidth: [this.fontSize(5), this.fontSize(10), this.fontSize(30)],
          align: ['center','center','center'],
          data: [],
        },
        dataList: this.beans,
        startCharts: null,
        beans: {
          type: Array,
          default: function () {
            return [];
          },
        },
        nowTime: null,
        weekTime: null,
        updateTimeText: null,
        titleMonth:"",
        titleYear:"",
        titleDay:"",
      };
    },
    watch: {
      beans: {
        handler: function (val, oldVal) {
          this.dataList = val;
          var data = [];
          for (var i = 0; i < this.dataList.length; i++) {
            console.log('--:', this.dataList[i]);
            var date = this.dataList[i]["date"];
            date = '<span style=\'font-size: 0.24rem;\'>' + date + '</span>';

            var status = this.dataList[i]["status"];
            switch(status){
              case 2:
                status = '客户质量问题';
                break;
              case 1:
                status = '内部质量问题';
                break;
              case 0:
                status = '无质量问题';
                break;
            }
            status = '<span style=\'font-size: 0.24rem;\'>' + status + '</span>';
            var remark = this.dataList[i]["remark"];
            remark = '<span style=\'font-size: 0.24rem;\'>' + remark + '</span>';
            var value = [date, status, remark];
            data.push(value);
          }

          this.config = {
            startCharts: "",
            header: ["<span style='font-size: 0.24rem;'>发生日期</span>",
              "<span style='font-size: 0.24rem;'>事件类型</span>",
              "<span style='font-size: 0.24rem;'>事件描述</span>"],
            headerBGC: "rgba(6, 30, 93, 0.5)",
            headerHeight: this.fontSize(0.5),
            oddRowBGC: "rgba(0, 44, 81, 0.8)",
            evenRowBGC: "rgba(10, 29, 50, 0.8)",
            rowNum: 3,
            columnWidth: [this.fontSize(5), this.fontSize(10), this.fontSize(30)],
            align: ['center','center','center'],
            data: data,
          };
        },
        deep: true,
      },
    },
    mounted() {
      this.initDate();
      this.onShow();
      this.isload = true;
      this.webSocket();
      this.loadData(); //保留http
      this.initEchartsEvent();
      //钟表
      setInterval(this.clock, 1000);
    },
    destroyed() {
      if (this.websock) {
        this.lockReconnect = true;
        this.websock.close();
      }
    },
    filters: {},
    methods: {
      fontSize(res) {
        let docEl = document.documentElement,
          clientWidth =
            window.innerWidth ||
            document.documentElement.clientWidth ||
            document.body.clientWidth;
        if (!clientWidth) return;
        let fontSize = 100 * (clientWidth / 1920);
        return res * fontSize;
      },
      clock() {
        //全局变量d，创建Date对象
        var d = new Date();
        //格式：2018-2-5  19:19:33
        this.nowTime = format(d, "yyyy-MM-dd HH:mm:ss");
        var weekTime = new Array(
          "星期日",
          "星期一",
          "星期二",
          "星期三",
          "星期四",
          "星期五",
          "星期六"
        )[d.getDay()];
        this.weekTime = weekTime;
      },
      tabClick() {
        this.init();
      },
      signOut() {
        router.back();
      },
      addQcDay() {
        API.addQcDay(this.qcFrom).then((res) => {
          if (res.success == true) {
          } else {
            this.$message.error(res.message);
          }
          this.dialogFormVisible = false;
          this.loadData();
        })
      },
      initDate() {
        var now = new Date(this.now);
        var year = now.getFullYear();
        var month = now.getMonth() + 1;
        for (var i = 0; i < 5; i++) {
          this.yearArry.push(year - i);
        }
        this.now = now;
        this.year = year;
        this.month = month;
        this.setMonthParam();
        this.setTitleMonth(month);
        this.titleDay = now.getUTCDate()
        this.titleYear = now.getFullYear();
      },
      initEchartsEvent() {
        var _this = this;
        var monthEchart = this.$echarts.init(
          document.getElementById("monthEchart")
        );
        monthEchart.on('click', function (param) {
          //获取自定义变量barIds的值,barIds要和option的series里自定义的一样
          // console.log('--:', param.data[2] + '月');
          _this.month = param.data[2];
          _this.setMonthParam();
          _this.loadData();
        });
        var lineEchart = this.$echarts.init(
          document.getElementById("deptCloseRateEchart")
        );
        //单击改变下方文本
        lineEchart.on('click', function (param) {
          _this.dayIndex = param.data;
          _this.option.series[2].data = [param.data];
          _this.now = new Date(param.data[0]);
          lineEchart.setOption(_this.option);
          for (var key in _this.dataSet) {
            if (key == param.data[0]) {
              _this.qcFrom.remark = _this.dataSet[key].remark;
              _this.qcFrom.status = _this.dataSet[key].status.toString();

              if (_this.qcFrom.status == "-1") {
                _this.qcFrom.status = "0";
              }
              _this.qcFrom.openedDate = key;
              break;
            }
          }
        });
        //双击设置
        lineEchart.on('dblclick', function (param) {
          console.log('--:', param);

          if (param.data[1] == "-1") {
            //白色且当前时间不大于单元格时间双击不弹编辑
            var now = new Date();
            var pDate = new Date(param.data[0]);
            if(now >= pDate){
              _this.dialogFormVisible = true;
            }
          } else {
            _this.dialogFormVisible = true;
          }

        });
      },
      yearFilter(y) {
        this.year = y;
        this.loadData();
      },
      setTitleMonth(month) {
        switch (month) {
          case 1:
            this.titleMonth = "January";
            break;
          case 2:
            this.titleMonth = "February";
            break;
          case 3:
            this.titleMonth = "March";
            break;
          case 4:
            this.titleMonth = "April";
            break;
          case 5:
            this.titleMonth = "May";
            break;
          case 6:
            this.titleMonth = "June";
            break;
          case 7:
            this.titleMonth = "July";
            break;
          case 8:
            this.titleMonth = "August";
            break;
          case 9:
            this.titleMonth = "September";
            break;
          case 10:
            this.titleMonth = "October";
            break;
          case 11:
            this.titleMonth = "November";
            break;
          case 12:
            this.titleMonth = "December";
            break;
          default:
            this.titleMonth = "";
            break;
        }
      },
      setMonthParam() {
        switch (this.month) {
          case 1:
            this.monthText = "January";
            this.monthIndex = 1;
            break;
          case 2:
            this.monthText = "February";
            this.monthIndex = 2;
            break;
          case 3:
            this.monthText = "March";
            this.monthIndex = 4;
            break;
          case 4:
            this.monthText = "April";
            this.monthIndex = 5;
            break;
          case 5:
            this.monthText = "May";
            this.monthIndex = 6;
            break;
          case 6:
            this.monthText = "June";
            this.monthIndex = 7;
            break;
          case 7:
            this.monthText = "July";
            this.monthIndex = 8;
            break;
          case 8:
            this.monthText = "August";
            this.monthIndex = 9;
            break;
          case 9:
            this.monthText = "September";
            this.monthIndex = 10;
            break;
          case 10:
            this.monthText = "October";
            this.monthIndex = 11;
            break;
          case 11:
            this.monthText = "November";
            this.monthIndex = 13;
            break;
          case 12:
            this.monthText = "December";
            this.monthIndex = 14;
            break;
          default:
            this.monthText = "";
            break;
        }
      },
      loadData() {
        API.loadTheme().then((re) => {
          this.isload = false;
          if (re.success && re["list"].length > 0) {
            this.logoSrc = re["list"][0]["icon"];
          }
        });
        var now = new Date(this.now);
        now.setFullYear(this.year);
        now.setMonth(this.month - 1);

        if (this.month - 1 != now.getMonth()) {
          now.setTime(now.getTime() - now.getDate() * 86400000)
        }

        this.now = now;
        now.setDate(now.getDate() - 1);
        
        var params = {begin: now.setHours(0, 0, 0, 0) + ""};
        API.getQcDay(params)
          .then((res) => {
            this.isload = false;
            if (res.success == true) {
              this.format(res);
              this.dataSet = res.value;
              this.init();
            } else {
              this.$message.error(res.message);
            }
          })
          .catch((error) => {
            this.$message.error("网络错误,数据查询失败");
          });
        API.getQcMonth(params)
          .then((res) => {
            this.isload = false;
            if (res.success == true) {
              for (var key in res.value) {
                var m = key.substring(5, 7);
                switch (m) {
                  case "01":
                    this.monthEchartData[1][3] = res.value[key];
                    break;
                  case "02":
                    this.monthEchartData[2][3] = res.value[key];
                    break;
                  case "03":
                    this.monthEchartData[4][3] = res.value[key];
                    break;
                  case "04":
                    this.monthEchartData[5][3] = res.value[key];
                    break;
                  case "05":
                    this.monthEchartData[6][3] = res.value[key];
                    break;
                  case "06":
                    this.monthEchartData[7][3] = res.value[key];
                    break;
                  case "07":
                    this.monthEchartData[8][3] = res.value[key];
                    break;
                  case "08":
                    this.monthEchartData[9][3] = res.value[key];
                    break;
                  case "09":
                    this.monthEchartData[10][3] = res.value[key];
                    break;
                  case "10":
                    this.monthEchartData[11][3] = res.value[key];
                    break;
                  case "11":
                    this.monthEchartData[13][3] = res.value[key];
                    break;
                  case "12":
                    this.monthEchartData[14][3] = res.value[key];
                    break;
                }
              }
              this.init();
            } else {
              this.$message.error(res.message);
            }
          })
          .catch((error) => {
            this.$message.error("网络错误,数据查询失败" + error.toString());
          });
      },
      init() {
        var lineEchart = this.$echarts.init(
          document.getElementById("deptCloseRateEchart")
        );
        var monthEchart = this.$echarts.init(
          document.getElementById("monthEchart")
        );
        var ym = format(this.now, "yyyy-MM");

        var data = this.dataSet;
        var lunarData = [];
        var yd = format(this.now, "yyyy-MM-dd");

        this.beans = [];
        var map = new Map();
        for (var key in this.dataSet) {
          map.set(key, this.dataSet[key]);
        }
        var arrayObj = Array.from(map);
        arrayObj.sort(function (a, b) {
          return a[0].localeCompare(b[0])
        })
        for (var [key, value] of arrayObj) {
          var bean = {};
          bean['date'] = key;
          bean['remark'] = value.remark;
          bean['status'] = value.status;
          if (bean['remark'] && bean['remark'] != '') {
            this.beans.push(bean);
          }

        }
        for (var key in data) {
          lunarData.push([key, data[key].status]);

          if (key == yd) {
            this.dayIndex = [];
            this.dayIndex.push(key);
            this.dayIndex.push(data[key]['status']);
          }
        }
        this.option = {
          visualMap: {
            type: "piecewise", // 类型为分段型
            show: false,
            calculable: true,
            seriesIndex: [1, 2],
            orient: "horizontal",
            left: "center",
            bottom: 20,
            pieces: [
              // 自定义每一段的范围，以及每一段的文字
              {lte: -1, color: "rgba(10, 29, 50, 1)"},
              {lte: 0, color: "#00b050"},
              {lte: 1, color: "#E5E96E"},
              {gte: 2, color: "#ff0000"},
            ],
            show: false
          },

          calendar: [
            {
              top: this.fontSize(0.7),
              left: this.fontSize(0.9),
			  right:this.fontSize(0.2),
              cellSize: ["auto", "auto"],
              yearLabel: {show: false},
              orient: "vertical",
              dayLabel: {
                //nameMap:['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
                nameMap:['周日', '周一', '周二', '周三', '周四', '周五', '周六'],
                verticalAlign:'middle',
                firstDay: 7,
                color: '#fff',
                fontSize: this.fontSize(0.24),
                align:'center',
                margin: this.fontSize(0.1),
              },
              splitLine:{
                lineStyle:{
                  opacity:0.5,
                  color:'#fff',
                  width:2,
                }
              },
              monthLabel: {
                padding: [0, this.fontSize(0.1), 0, 0],
                show: true,
                color: '#fff',
                nameMap: "cn",
                fontSize: this.fontSize(0.24),
                overflow:'break'
              },
              range: ym,
            },
          ],
          series: [
            {
              type: "scatter",
              coordinateSystem: "calendar",
              symbolSize: 1,
              label: {
                show: true,
                formatter: function (params) {
                  return new Date(params.value[0]).getDate();
                },
                color: "#fff",
                fontSize: this.fontSize(0.24),
                fontWeight: 400,

              },
              data: lunarData,
            },
            {
              type: "heatmap",
              coordinateSystem: "calendar",
              symbolSize: 1,
              data: lunarData,
              itemStyle: {
                borderWidth: 0.5,
                borderColor: "#454839",
              }
            },
            {
              type: "heatmap",
              coordinateSystem: "calendar",
              symbolSize: 1,
              silent: false,
              itemStyle: {
                borderWidth: 0.5,
                borderColor: "#ffffff",
              },
              data: [this.dayIndex],
            },
          ],
        };
        lineEchart.setOption(this.option);
        const hours = [
          '', '', '', ''
        ];
        const days = [
          '', '', '', ''
        ];
        const monthEchartOption = {
          tooltip: {
            position: 'top'
          },
          grid: {
            left: 0,
            right: 0,
            bottom: 0,
            top: 0
          },
          xAxis: {
            type: 'category',
            data: hours,
            splitArea: {
              show: true
            },
            show: false,
          },
          yAxis: {
            type: 'category',
            data: days,
            splitArea: {
              show: true
            },
            show: false,
          },
          visualMap: {
            type: "piecewise",
            calculable: false,
            orient: 'vertical',
            left: 'center',
            bottom: 0,
            top: 0,
            pieces: [
              {lte: -1, color: "rgba(10, 29, 50, 0.8)"},
              {lte: 0, color: "#00b050"},
              {lte: 1, color: "#E5E96E"},
              {lte: 2, color: "#ff0000"},
            ],
            show: false
          },
          series: [
            {
              name: 'Punch Card',
              type: 'heatmap',
              data: this.monthEchartData,
              silent: false,
              tooltip: {
                position: [-10000, -10000]
              },
              itemStyle: {
                borderWidth: 1,
                borderColor: "#454839",
              }
              ,
              label: {
                show: true,
                color: '#fff',
                fontSize: this.fontSize(0.24),
                formatter: function (params) {
                  var text = '';
                  switch (params.value[2]) {
                    case 1:
                      text = "一月"
                      break;
                    case 2:
                      text = "二月";
                      break;
                    case 3:
                      text = "三月";
                      break;
                    case 4:
                      text = "四月";
                      break;
                    case 5:
                      text = "五月";
                      break;
                    case 6:
                      text = "六月";
                      break;
                    case 7:
                      text = "七月";
                      break;
                    case 8:
                      text = "八月";
                      break;
                    case 9:
                      text = "九月";
                      break;
                    case 10:
                      text = "十月";
                      break;
                    case 11:
                      text = "十一月";
                      break;
                    case 12:
                      text = "十二月";
                      break;
                    default:
                      text = '';
                  }
                  return text;
                },
              },
            },
            {
              type: 'heatmap',
              tooltip: {
                position: [-10000, -10000]
              },
              itemStyle: {
                borderWidth: 1,
                borderColor: "#ffffff",
              },
              label: {
                show: true,
                color: '#fff',
                fontSize: this.fontSize(0.24),
                formatter: function (params) {
                  var text = '';
                  switch (params.value[2]) {
                    case 1:
                      text = "一月"
                      break;
                    case 2:
                      text = "二月";
                      break;
                    case 3:
                      text = "三月";
                      break;
                    case 4:
                      text = "四月";
                      break;
                    case 5:
                      text = "五月";
                      break;
                    case 6:
                      text = "六月";
                      break;
                    case 7:
                      text = "七月";
                      break;
                    case 8:
                      text = "八月";
                      break;
                    case 9:
                      text = "九月";
                      break;
                    case 10:
                      text = "十月";
                      break;
                    case 11:
                      text = "十一月";
                      break;
                    case 12:
                      text = "十二月";
                      break;
                    default:
                      text = '';
                  }
                  return text;
                },
              },
              data: [this.monthEchartData[this.monthIndex]],
            },
          ]
        };
        monthEchart.setOption(monthEchartOption);
      },
      dataSlice(index, data) {
        var open = (index - 1) * this.pageSize;
        var end = index * this.pageSize;
        return data.slice(open, end);
      },
      //格式化数据
      format(res) {
        var now = new Date();
        this.updateTimeText = format(now, "MM-dd HH:mm:ss");
      },
      webSocket() {
        var http = sessionStorage.getItem("http");
        var uuid = this.$route.query.key;
        if (http) {
          http += "/websocket/oee/monitoring";
        } else {
          http = "https://demo.biqs.cn/websocket/oee/monitoring";
        }

        http = http.replace("https", "wss").replace("http", "ws");

        this.websock = new WebSocket(http);
        this.websock.onopen = this.websocketonopen; //连接成功
        this.websock.onmessage = this.websocketonmessage; //广播成功
        this.websock.onerror = this.websocketonerror; //连接断开，失败
        this.websock.onclose = this.websocketclose;

        let this_ = this;
      },
      //连接成功
      websocketonopen() {
        console.log("Qplot socket 连接成功");
      },

      //连接失败
      websocketonerror() {
        console.log("Qplot socket 连接失败");
        this.reconnect();
      },

      //各种问题导致的 连接关闭
      websocketclose() {
        console.log(" Qplot socket 断开连接");
        this.reconnect();
      },
      //数据接收
      websocketonmessage(data) {
        //刷新
        this.loadData();
      },

      //断开重连
      reconnect() {
        if (this.lockReconnect) {
          return;
        }
        this.reconnectData && clearTimeout(this.reconnectData);
        this.reconnectData = setTimeout(() => {
          this.webSocket();
        }, 5000);
      },

      onShow() {
        localStorage.getItem("setUp");
        var setUp = localStorage.getItem("setUp");
        if (setUp) {
          setUp = JSON.parse(setUp);
          this.pageSize = setUp["pageSize"];
          this.too = setUp["too"] * 1000;
        }
      },
      removeTAG(str) {
        if (str) {
          return str.replace(/<[^>]+>/g, "");
        } else {
          return str;
        }
      },
      formatDate(time) {
        if (time) {
          console.log(time);
          var date = new Date(Number(time));
          return format(date, "yyyy-MM-dd");
        }
        return "";
      },
      formatHour(time) {
        if (time) {
          var date = new Date(Number(time));
          return format(date, "MM/dd HH:mm");
        }
        return "";
      },
      back() {
        router.back();
      },
    },
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped src='./board.css'></style>



// WEBPACK FOOTER //
// src/pages/oee/mm/qc/board.vue